<div>
	<div class="row">
		<label class="col-md-2 col-form-label-sm">Operation:</label>
		@if (!multiOps) {
			<div class="col-md-6">
				@if (operations !== undefined) {
					<select class="form-control form-control-sm op-list" [(ngModel)]="operation" (ngModelChange)="refreshCheck()"
						[title]="operations | operationslimitnote : 'vibe' : rotor.rotorid">
						@for (operation of operations; track operation) {
							<option [ngValue]="operation" [class]="GetOpClass(operation)">
								{{operation | operationlabel : (fleet ? fleet.time_offset_hours : 0) : true}}
							</option>
						}
					</select>
				}
				@if (operations === undefined) {
					<select class="form-control form-control-sm" disabled>
						<option>Loading RTB operations...</option>
					</select>
				}
			</div>
		}
		@if (multiOps) {
			<div class="col-md-6">
				@if (operations !== undefined) {
					<select class="form-control form-control-sm" [(ngModel)]="multiOperation" (ngModelChange)="refreshCheck()"
						[title]="operations | operationslimitnote : 'vibe' : rotor.rotorid"
						multiple>
						@for (operation of operations; track operation) {
							<option [ngValue]="operation">
								{{operation.start_time | datetime : "offset" : (fleet ? fleet.time_offset_hours : 0)}}
							</option>
						}
					</select>
				}
				@if (operations === undefined) {
					<select class="form-control form-control-sm" disabled multiple>
						<option>Loading RTB operations...</option>
					</select>
				}
			</div>
		}
		<div class="col-md-4">
			<label class="col-form-label-sm">
				<input [(ngModel)]="multiOps" type="checkbox">
				Multiple operations
			</label>
			@if (multiOps) {
				<p>Ctrl+click to select multiple operations, 5 maximum</p>
			}
		</div>
	</div>

	<app-dvs-chart [options]="boxPlotOptions" [error]="plotError"></app-dvs-chart>
</div>